import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/featureGroup/license.featureGroup.features.set.mutation.gql"
import type {
  FeatureGroupFeaturesSetMutation,
  FeatureGroupFeaturesSetMutationVariables,
} from "@/v2-backoffice-client/license/featureGroup/__types__/license.featureGroup.features.set.mutation"

type Options = MutationHookOptions<
  FeatureGroupFeaturesSetMutation,
  FeatureGroupFeaturesSetMutationVariables
>

export function useFeatureGroupFeaturesSetMutation(options?: Options) {
  return useMutation<
    FeatureGroupFeaturesSetMutation,
    FeatureGroupFeaturesSetMutationVariables
  >(mutation, options)
}
